import { Container } from '~/components/Container';
import {
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
  Accordion as ShadAccordion,
} from '~/components/ui/accordion';
import type { AcfAccordion } from '~/types/graphql';

export function Accordion({
  accordion,
  isSmall = true,
  className,
}: AcfAccordion & { isSmall?: boolean; className?: string }) {
  if (!accordion?.items) return null;

  return (
    <Container isSmall={isSmall} className={className ?? 'py-16'}>
      <ShadAccordion type="single" collapsible className="flex flex-col">
        {accordion.items.map((item, i) => (
          <AccordionItem value={`${item}-${i}`} key={i}>
            <AccordionTrigger headline={item?.headline ?? ''} />
            <AccordionContent content={item?.content ?? ''} />
          </AccordionItem>
        ))}
      </ShadAccordion>
    </Container>
  );
}
